import React, { useState } from 'react';
import i18n from 'i18n-js';
import { withStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemText from '@material-ui/core/ListItemText';
import RemoveCircleOutlineIcon from '@material-ui/icons/RemoveCircleOutline';
import SettingsBackupRestoreIcon from '@material-ui/icons/SettingsBackupRestore';
import { PopupConfirmation } from 'components/shared';

const StyledMenuItem = withStyles((theme) => ({
    root: {
        '&:focus': {
            backgroundColor: theme.palette.primary.main,
            '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
                color: theme.palette.common.white,
            },
        },
    },
}))(MenuItem);

export interface Props {
    isDisabled: boolean;
    id: string;
    onClose: any;
    onToggleDisableSection: (id: string) => void;
    title?: string;
    isCourse?: boolean;
}

export default function DisableEnableSection({
    isDisabled,
    id,
    onClose,
    onToggleDisableSection,
    title,
    isCourse,
}: Props) {
    const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);

    function handleSecionStatus() {
        onClose();
        onToggleDisableSection(id);
    }

    function prepareTitle() {
        if (isCourse) {
            return isDisabled ? i18n.t('common.enableCourse') : i18n.t('common.disableCourse');
        } else {
            return isDisabled ? i18n.t('common.enableSection') : i18n.t('common.disableSection');
        }
    }

    function prepareConfirmationMessage() {
        if (isCourse) {
            return isDisabled
                ? i18n.t('confirmation.enableCourse')
                : i18n.t('confirmation.disableCourse');
        } else {
            return isDisabled
                ? i18n.t('confirmation.enableSection')
                : i18n.t('confirmation.disableSection');
        }
    }

    return (
        <>
            <StyledMenuItem
                color="primary"
                onClick={(e) => {
                    e.stopPropagation();
                    setShowConfirmationPopup(true);
                }}
            >
                {isDisabled ? (
                    <SettingsBackupRestoreIcon
                        fontSize="small"
                        color="disabled"
                        style={{ marginRight: 23 }}
                    />
                ) : (
                    <RemoveCircleOutlineIcon
                        fontSize="small"
                        color="disabled"
                        style={{ marginRight: 23 }}
                    />
                )}
                <ListItemText
                    primary={
                        title
                            ? title
                            : isDisabled
                            ? i18n.t('common.enable')
                            : i18n.t('common.disable')
                    }
                />
            </StyledMenuItem>
            <PopupConfirmation
                open={showConfirmationPopup}
                close={() => setShowConfirmationPopup(false)}
                title={prepareTitle()}
                description={prepareConfirmationMessage()}
                activeBtn={isDisabled ? i18n.t('common.enable') : i18n.t('common.disable')}
                action={handleSecionStatus}
            />
        </>
    );
}
